export default "__VITE_ASSET__8c7b4084__"